import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import SectionHeading from "@/components/base/SectionHeading";

export default function CategoryGrid() {
  return (
    <section className="border-b border-background-200 bg-background-50 px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        eyebrow="主题分类"
        title="按你关心的话题方向逛"
        desc="六个常设栏目，覆盖从人物风波到影视幕后的话题类型。"
      />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.id}`}
            className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-300 hover:bg-accent-50/60"
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-accent-600">
              <i className={`${cat.icon} text-xl`}></i>
            </span>
            <span className="min-w-0">
              <span className="flex items-center gap-2">
                <span className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700">
                  {cat.name}
                </span>
                <span className="rounded-full bg-background-200 px-2 py-0.5 text-[11px] text-foreground-600">
                  {cat.entryCount}
                </span>
              </span>
              <span className="mt-1.5 block text-xs leading-relaxed text-foreground-600">
                {cat.desc}
              </span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}